import TitleBar from '../../../../../components/TitleBar';
import { useParams } from 'react-router-dom';
import { Footer } from '../../../../../components/common/Footer';
import { ActivationCriteriaTable, IndividualsTable } from '..';

import useBCPMetaData from '../../../../../hooks/useBCPMetaData';
import QueryErrorBoundary from '../../../../../components/error-handling';
import { Spinner } from '../../../../../components';
import TitleUpdater from '../../../../../components/common/TitleUpdater';

export default function Activation() {
  const params = useParams();
  const { type, locationId } = params;

  const isLocationType = type === 'location';

  const { planUUID, locationName, loading, error } = useBCPMetaData(
    locationId!,
    isLocationType,
  );

  const backPath = `/bcp-landing/${type}/${locationId}`;

  return (
    <>
      <TitleUpdater title={`Plan Activation Criteria`} />
      <TitleBar
        title="BCP Hub"
        subtitle="Plan Activation Criteria"
        brief="In the event of a prolonged business disruption, who has the authority to activate / deactivate the location business continuity plan?"
      />
      <p className="my-2 text-black font-normal text-sm tracking-wider">
        Enter at least 3 different individuals:
      </p>
      {}
      <QueryErrorBoundary error={error}>
        {!loading ? (
          <div className="mb-12">
            <IndividualsTable planId={planUUID} />
            <p className="my-10   text-black text-sm tracking-wider font-normal">
              While each business disruption is unique, it is important to
              define the varying levels of a disruption, including when the BCP
              most likely needs to be activated. When defining these levels, it
              is important that the escalations are time driven, not event
              driven. For example, a 6-month disruption at a location could
              occur for several reasons (e.g.: flood, fire, etc.). Most
              companies would define this as a level 3 event, causing severe
              disruption to only part of the business.
            </p>
            <ActivationCriteriaTable planId={planUUID} />
          </div>
        ) : (
          <Spinner />
        )}
      </QueryErrorBoundary>
      <Footer backPath={backPath} />
    </>
  );
}
